import { render, staticRenderFns } from "./templates-loader.vue?vue&type=template&id=33fec204"
import script from "./templates-loader.vue?vue&type=script&lang=js"
export * from "./templates-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports